<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3333 1.66667L18.3333 -7.28519e-08L1.66668 -8.01375e-07L1.66668 1.66667L18.3333 1.66667Z"
            fill="black" />
        <path d="M20 1.66671L18.3333 1.66667L18.3333 5.00002L20 5.00002L20 1.66671Z" fill="black" />
        <path d="M18.3333 5.00002L16.6667 5L16.6667 8.33336L18.3333 8.33338L18.3333 5.00002Z" fill="black" />
        <path d="M16.6667 8.33336L15 8.33336L15 11.6667L16.6667 11.6667L16.6667 8.33336Z" fill="black" />
        <path d="M15 11.6667L13.3333 11.6667L13.3333 15L15 15L15 11.6667Z" fill="black" />
        <path d="M13.3333 15L11.6667 15L11.6667 18.3334L13.3333 18.3334L13.3333 15Z" fill="black" />
        <path d="M8.33332 18.3334L8.33332 20L11.6667 20L11.6667 18.3334L8.33332 18.3334Z" fill="black" />
        <path d="M8.33334 15L6.66668 15L6.66668 18.3334L8.33332 18.3334L8.33334 15Z" fill="black" />
        <path d="M6.66667 11.6667L5 11.6667L5 15L6.66668 15L6.66667 11.6667Z" fill="black" />
        <path d="M4.99999 8.33336L3.33332 8.33336L3.33332 11.6667L5 11.6667L4.99999 8.33336Z" fill="black" />
        <path d="M3.33334 5L1.66667 5.00002L1.66668 8.33338L3.33332 8.33336L3.33334 5Z" fill="black" />
        <path d="M1.66668 1.66667L-7.28543e-08 1.66671L-2.18558e-07 5.00002L1.66667 5.00002L1.66668 1.66667Z"
            fill="black" />
        <path
            d="M18.334 5.00008L18.334 1.66675L1.66732 1.66675L1.66732 5.00008L3.33399 5.00008L3.33399 8.33341L5.00065 8.33341L5.00065 11.6667L6.66732 11.6667L6.66732 15.0001L8.33398 15.0001L8.33398 18.3334L11.6673 18.3334L11.6673 15.0001L13.334 15.0001L13.334 11.6667L15.0007 11.6667L15.0007 8.33341L16.6673 8.33341L16.6673 5.00008L18.334 5.00008Z"
            fill="#D7DF23" />
    </svg>
</template>

<script>
export default {
  name: 'DownButton',
  props: {
    color: {
      type: String,
      default: '#D7DF23',
    },
    width: {
      type: String,
      default: '24',
    },
    height: {
      type: String,
      default: '24',
    },
  },
};
</script>